import { useEffect, useState } from "react";
import axios from "axios";
import { FaPlus, FaEdit, FaTrash, FaUserTie, FaCheckCircle, FaTimesCircle, FaTrophy, FaUserShield } from "react-icons/fa";
import "../styles/profissionaisAdmin.css"; 

const ProfissionaisAdmin = () => {
  const [abaAtiva, setAbaAtiva] = useState("corrida"); 

  const [eventos, setEventos] = useState([]);
  const [eventoId, setEventoId] = useState("");
  const [profissionais, setProfissionais] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [form, setForm] = useState({ _id: "", nome: "", funcao: "juiz_cabine", codigo: "", ativo: true });

  const [circuitos, setCircuitos] = useState([]);
  const [gerentes, setGerentes] = useState([]);
  const [modalGerente, setModalGerente] = useState(false);
  
  // 💡 ADICIONADO CPF E WHATSAPP NO FORM
  const [formGerente, setFormGerente] = useState({ nomeCompleto: "", email: "", senha: "", circuitoId: "", cpf: "", whatsapp: "" });

  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    // 💡 ADICIONADO HEADERS COM TOKEN PARA BUSCAR OS EVENTOS E CIRCUITOS
    axios.get("https://api.ticketdovaqueiro.com/api/events", { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setEventos(res.data)).catch(console.error);
      
    axios.get("https://api.ticketdovaqueiro.com/api/circuitos", { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setCircuitos(res.data)).catch(console.error);
      
    carregarGerentes();
  }, []);

  useEffect(() => {
    if (eventoId) carregarProfissionais();
    else setProfissionais([]);
  }, [eventoId]);

  const carregarProfissionais = async () => {
    setLoading(true);
    try {
        const res = await axios.get(`https://api.ticketdovaqueiro.com/api/profissionais?eventoId=${eventoId}`, { headers: { Authorization: `Bearer ${token}` } });
        setProfissionais(res.data);
    } finally { setLoading(false); }
  };

  const abrirModalCriacao = () => {
    if (!eventoId) return alert("Selecione um evento primeiro.");
    setModoEdicao(false); setForm({ _id: "", nome: "", funcao: "juiz_cabine", codigo: "", ativo: true }); setModalAberto(true);
  };
  
  const gerarCodigoAleatorio = (e) => { e.preventDefault(); setForm({ ...form, codigo: Math.floor(1000 + Math.random() * 9000).toString() }); };
  
  const salvarProfissional = async (e) => {
    e.preventDefault();
    try {
        if (modoEdicao) await axios.put(`https://api.ticketdovaqueiro.com/api/profissionais/${form._id}`, form, { headers: { Authorization: `Bearer ${token}` } });
        else await axios.post("https://api.ticketdovaqueiro.com/api/profissionais", { ...form, eventoId }, { headers: { Authorization: `Bearer ${token}` } });
        alert("Salvo com sucesso!"); setModalAberto(false); carregarProfissionais();
    } catch (e) { alert("Erro ao salvar"); }
  };
  
  const deletarProfissional = async (id) => {
    if (!window.confirm("Excluir?")) return;
    await axios.delete(`https://api.ticketdovaqueiro.com/api/profissionais/${id}`, { headers: { Authorization: `Bearer ${token}` } }); carregarProfissionais();
  };

  const carregarGerentes = async () => {
    try {
        const res = await axios.get("https://api.ticketdovaqueiro.com/api/auth/gerentes-circuito", { headers: { Authorization: `Bearer ${token}` } });
        setGerentes(res.data);
    } catch (e) { console.error("Erro ao carregar gerentes"); }
  };

  const salvarGerente = async (e) => {
      e.preventDefault();
      try {
          setLoading(true);
          await axios.post("https://api.ticketdovaqueiro.com/api/auth/register-gerente", formGerente, { headers: { Authorization: `Bearer ${token}` } });
          alert("Acesso do Circuito criado com sucesso!");
          setModalGerente(false);
          setFormGerente({ nomeCompleto: "", email: "", senha: "", circuitoId: "", cpf: "", whatsapp: "" });
          carregarGerentes();
      } catch (err) {
          alert(err.response?.data?.erro || "Erro ao criar acesso");
      } finally { setLoading(false); }
  };

  return (
    <div className="pa-container">
      <div className="pa-header">
        <h1><FaUserShield style={{color: "var(--c-accent)"}} /> Gestão de Acessos</h1>
        <p>Controle senhas de profissionais e gerentes de circuitos</p>
      </div>

      {/* ABAS MODERNAS */}
      <div className="pa-tabs">
        <button className={abaAtiva === "corrida" ? "active" : ""} onClick={() => setAbaAtiva("corrida")}>
          <FaUserTie /> Equipe da Corrida
        </button>
        <button className={abaAtiva === "circuitos" ? "active" : ""} onClick={() => setAbaAtiva("circuitos")}>
          <FaTrophy /> Donos de Circuito
        </button>
      </div>

      {/* TELA DE PROFISSIONAIS (JUIZ/LOCUTOR) */}
      {abaAtiva === "corrida" && (
          <div className="pa-card">
            <div className="pa-filtros">
                <div className="pa-input-group">
                    <label>Selecione o Evento</label>
                    <select className="pa-select" value={eventoId} onChange={e => setEventoId(e.target.value)}>
                        <option value="">-- Escolha um evento --</option>
                        {eventos.map(ev => <option key={ev._id} value={ev._id}>{ev.nome || ev.nomeEvent}</option>)}
                    </select>
                </div>
                <button className="pa-btn-primary" onClick={abrirModalCriacao} disabled={!eventoId}><FaPlus /> Adicionar Membro</button>
            </div>
            
            <div className="pa-table-wrapper">
                <table className="pa-table">
                    <thead><tr><th>Profissional</th><th>Função</th><th>Painel Destino</th><th>Código de Acesso</th><th>Ações</th></tr></thead>
                    <tbody>
                        {!eventoId ? (
                             <tr><td colSpan="5" className="pa-empty">Selecione um evento para ver a equipe.</td></tr>
                        ) : profissionais.length === 0 ? (
                             <tr><td colSpan="5" className="pa-empty">Nenhum profissional cadastrado.</td></tr>
                        ) : (
                            profissionais.map(p => (
                                <tr key={p._id}>
                                    <td><strong>{p.nome}</strong></td>
                                    <td><span className="pa-badge pa-badge-gray">{p.funcao.replace("_", " ").toUpperCase()}</span></td>
                                    <td><span className={`pa-badge ${p.painel === 'juiz' ? 'pa-badge-red' : 'pa-badge-blue'}`}>{p.painel.toUpperCase()}</span></td>
                                    <td><span className="pa-codigo">{p.codigo}</span></td>
                                    <td><button className="pa-btn-icon pa-text-red" onClick={() => deletarProfissional(p._id)}><FaTrash/></button></td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
          </div>
      )}

      {/* TELA DE GERENTES DE CIRCUITO */}
      {abaAtiva === "circuitos" && (
          <div className="pa-card">
             <div className="pa-filtros" style={{ justifyContent: "space-between" }}>
                <div>
                   <h3>Acessos de Circuitos</h3>
                   <p style={{fontSize: 13, color: "#888", margin: 0}}>Quem pode acessar o painel de cada campeonato.</p>
                </div>
                <button className="pa-btn-primary" onClick={() => setModalGerente(true)}><FaPlus /> Criar Acesso</button>
            </div>

            <div className="pa-table-wrapper">
                <table className="pa-table">
                    <thead><tr><th>Dono / Gerente</th><th>Contato</th><th>E-mail de Login</th><th>Circuito Controlado</th></tr></thead>
                    <tbody>
                        {gerentes.length === 0 ? (
                            <tr><td colSpan="4" className="pa-empty">Nenhum acesso de circuito criado.</td></tr>
                        ) : (
                            gerentes.map(g => (
                                <tr key={g._id}>
                                    <td><strong>{g.nomeCompleto}</strong><br/><small style={{color: "#666"}}>{g.cpf}</small></td>
                                    <td>{g.whatsapp}</td>
                                    <td>{g.email}</td>
                                    <td><span className="pa-badge pa-badge-gold">{g.circuitoId?.nome || "Sem vínculo"}</span></td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
          </div>
      )}

      {/* MODAL: EQUIPE CORRIDA */}
      {modalAberto && (
        <div className="pa-modal-overlay">
            <div className="pa-modal">
                <h2>{modoEdicao ? "Editar Profissional" : "Adicionar à Equipe"}</h2>
                <form onSubmit={salvarProfissional}>
                    <div className="pa-form-grid">
                        <div className="pa-input-group" style={{gridColumn: "1 / -1"}}>
                            <label>Nome Completo</label>
                            <input required className="pa-input" type="text" value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} />
                        </div>
                        <div className="pa-input-group">
                            <label>Função no Evento</label>
                            <select className="pa-select" value={form.funcao} onChange={e => setForm({...form, funcao: e.target.value})}>
                                <option value="juiz_cabine">Juiz de Cabine</option>
                                <option value="juiz_tv">Juiz de TV / Alternativo</option>
                                <option value="anotador_juiz">Anotador (Juiz)</option>
                                <option value="locutor">Locutor</option>
                                <option value="anotador_locucao">Anotador (Locução)</option>
                            </select>
                        </div>
                        <div className="pa-input-group">
                            <label>Senha / Código (6 dig.)</label>
                            <div style={{display: "flex", gap: "8px", width: "100%"}}>
                                <input 
                                    required 
                                    className="pa-input" 
                                    style={{flex: 1}} 
                                    type="text" 
                                    maxLength={6} 
                                    value={form.codigo} 
                                    onChange={e => setForm({...form, codigo: e.target.value.toUpperCase()})} 
                                />
                                <button type="button" className="pa-btn-outline" onClick={gerarCodigoAleatorio}>
                                    Gerar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="pa-modal-actions">
                        <button type="button" className="pa-btn-ghost" onClick={() => setModalAberto(false)}>Cancelar</button>
                        <button type="submit" className="pa-btn-primary">Salvar</button>
                    </div>
                </form>
            </div>
        </div>
      )}

      {/* MODAL: GERENTE CIRCUITO */}
      {modalGerente && (
        <div className="pa-modal-overlay">
            <div className="pa-modal" style={{maxWidth: 600}}>
                <h2>Criar Acesso: Dono de Circuito</h2>
                <form onSubmit={salvarGerente}>
                    <div className="pa-form-grid">
                        <div className="pa-input-group" style={{gridColumn: "1 / -1"}}>
                            <label>Selecione o Circuito que ele vai controlar *</label>
                            <select required className="pa-select" value={formGerente.circuitoId} onChange={e => setFormGerente({...formGerente, circuitoId: e.target.value})}>
                                <option value="">-- Selecione o Circuito --</option>
                                {circuitos.map(c => <option key={c._id} value={c._id}>{c.nome}</option>)}
                            </select>
                        </div>

                        <div className="pa-input-group" style={{gridColumn: "1 / -1"}}>
                            <label>Nome do Gerente/Dono *</label>
                            <input required className="pa-input" type="text" value={formGerente.nomeCompleto} onChange={e => setFormGerente({...formGerente, nomeCompleto: e.target.value})} />
                        </div>

                        <div className="pa-input-group">
                            <label>CPF *</label>
                            <input required className="pa-input" type="text" placeholder="000.000.000-00" value={formGerente.cpf} onChange={e => setFormGerente({...formGerente, cpf: e.target.value})} />
                        </div>
                        <div className="pa-input-group">
                            <label>WhatsApp *</label>
                            <input required className="pa-input" type="text" placeholder="(00) 00000-0000" value={formGerente.whatsapp} onChange={e => setFormGerente({...formGerente, whatsapp: e.target.value})} />
                        </div>

                        <div className="pa-input-group">
                            <label>E-mail de Login *</label>
                            <input required className="pa-input" type="email" value={formGerente.email} onChange={e => setFormGerente({...formGerente, email: e.target.value})} />
                        </div>
                        <div className="pa-input-group">
                            <label>Senha de Acesso *</label>
                            <input required className="pa-input" type="text" value={formGerente.senha} onChange={e => setFormGerente({...formGerente, senha: e.target.value})} />
                        </div>
                    </div>
                    <div className="pa-modal-actions">
                        <button type="button" className="pa-btn-ghost" onClick={() => setModalGerente(false)}>Cancelar</button>
                        <button type="submit" className="pa-btn-primary" disabled={loading}>{loading ? "Salvando..." : "Criar Acesso"}</button>
                    </div>
                </form>
            </div>
        </div>
      )}

    </div>
  );
};

export default ProfissionaisAdmin;